var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgForward = function SvgForward(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "forward_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#forward_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.472 7.913 10.625 12l-6.153 4.087V7.913Zm7.028 2.888L4.52 6.165C3.869 5.73 3 6.205 3 6.994v10.012c0 .79.868 1.263 1.52.83l6.98-4.637v3.807c0 .79.868 1.263 1.52.83l7.538-5.007a.998.998 0 0 0 0-1.658L13.02 6.165c-.653-.434-1.521.04-1.521.829V10.8Zm1.472-2.888L19.125 12l-6.153 4.087V7.913Z",
    fill: "currentColor"
  }))));
};
export default SvgForward;